import { addBackToTop } from 'vanilla-back-to-top';

addBackToTop({
  diameter: 40,
  backgroundColor: '#ddd',
  textColor: '#ff6b08',
});